<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body
  >
    <el-form ref="form" :model="form" label-width="90px">
      <el-form-item label="文件路径">
        <el-upload
          class="upload-demo"
          :action="$baseURL + 'common/upload/file'"
          :headers="header"
          :on-remove="handleRemove"
          :on-success="onSuccess"
          multiple
          v-model:file-list="fileList"
        >
          <el-button size="small" type="primary">选取文件</el-button>
          <span style="color: red; margin-left: 10px"
            >注意：上传文件会覆盖之前的文件</span
          >
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
      </el-form-item>
      <el-form-item label="合同主体">
        <el-input
          v-model="form.contractSubject"

          placeholder="请输入合同主体"
        />
      </el-form-item>
      <el-form-item label="公司简称">
        <el-input
          v-model="form.companyName"

          placeholder="请输入公司简称"
        />
      </el-form-item>
      <el-form-item label="签订单位">
        <el-input
          v-model="form.nit"

          placeholder="请输入签订单位"
        />
      </el-form-item>
      <el-form-item label="合同方">
        <el-radio v-model="form.contractor" :label="1">上游</el-radio>
        <el-radio v-model="form.contractor" :label="2">下游</el-radio>
      </el-form-item>
      <el-form-item label="合同类型">
        <el-checkbox-group v-model="form.contractType">
          <el-checkbox label="1">CPM</el-checkbox>
          <el-checkbox label="2">CPD</el-checkbox>
          <el-checkbox label="3">CPS</el-checkbox>
          <el-checkbox label="4">CPA</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="有效日期">
        <el-date-picker
          v-model="value1"
          type="date"
          placeholder="选择日期"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item label="截至日期">
        <el-date-picker
          v-model="value2"
          type="date"
          placeholder="选择日期"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="close" >取消</el-button>
      <el-button
        @click="submit"
        type="primary"

        :loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { addContract, updateContract } from '@/api/manage/contract/contract'
import { formatDate, PURE_DATE_PATTERN } from '@/util/format'
import { mapGetters } from 'vuex'

const form = {
  contractId: undefined,
  contractUrls: '',
  effectiveDate: '',
  expirationDate: '',
  contractSubject: '',
  companyName: '',
  nit: '',
  contractor: 1,
  contractType: ['1']
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      fileList: [],
      value1: '',
      value2: '',
      header: {},
      isUpfile: false
    }
  },
  computed: {
    ...mapGetters(['access_token']),
    dialogTitle () {
      return (
        (this.title ? this.title : '') +
        (this.form.contractId ? '编辑' : '新增')
      )
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
  },
  methods: {
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        this.form.contractUrls = this.form.contractUrl
        this.form.contractType = this.form.contractType.split(',')
        delete this.form.contractUrl
        if (data.effectiveDate) {
          const effectiveDate = data.effectiveDate.toString().split('')
          effectiveDate.splice(4, 0, '-')
          effectiveDate.splice(7, 0, '-')
          this.value1 = effectiveDate.join('')
        }
        if (data.expirationDate) {
          const expirationDate = data.expirationDate.toString().split('')
          expirationDate.splice(4, 0, '-')
          expirationDate.splice(7, 0, '-')
          this.value2 = expirationDate.join('')
        }
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      if (
        this.value1 &&
        this.value2 &&
        (this.fileList[0] || this.form.contractUrls[0]) &&
        this.form.nit &&
        this.form.companyName &&
        this.form.contractSubject
      ) {
        this.form.contractType = this.form.contractType.join(',')
        const contractUrls = []
        this.fileList.map((item) => {
          contractUrls.push(item.response.data[0])
        })
        if (contractUrls[0]) {
          this.form.contractUrls = contractUrls.join(',')
        } else {
          this.form.contractUrls = null
        }
        if (typeof this.value1 === 'object') {
          this.form.effectiveDate = Number(
            formatDate(this.value1, PURE_DATE_PATTERN)
          )
        } else if (typeof this.value1 === 'string') {
          const reg = new RegExp('-', 'g')
          this.form.effectiveDate = this.value1
            ? Number(this.value1.replace(reg, ''))
            : null
        }

        if (typeof this.value2 === 'object') {
          this.form.expirationDate = Number(
            formatDate(this.value2, PURE_DATE_PATTERN)
          )
        } else if (typeof this.value2 === 'string') {
          const reg = new RegExp('-', 'g')
          this.form.expirationDate = this.value2
            ? Number(this.value2.replace(reg, ''))
            : null
        }
        console.log(this.value2)
        if (this.form.contractId) {
          console.log(this.form)
          this.updateContract(this.form)
        } else {
          this.addContract(this.form)
        }
      } else {
        this.$message.error('所有数据不能为空')
      }
    },
    addContract (form) {
      this.submitLoading = true
      addContract(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    updateContract (form) {
      this.submitLoading = true
      updateContract(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    reset () {
      this.form = Object.assign({}, form)
      this.contractUrls = []
      this.$refs.form.resetFields()
      this.fileList = [];
      (this.value1 = ''), (this.value2 = '')
    },
    handleRemove (file, fileList) {
      this.fileList = fileList
    },
    onSuccess (res, file, fileList) {
      if (res.code === 200) {
        this.fileList = fileList
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
.contractUrlsBox {
  margin-top: 10px;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #beeae4;
  border-radius: 10px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
